import { add, clone, equals, pipe, prop, pluck,flatten,slice,drop, sortWith,is,map,isNil, reject, omit,values,uniqWith,without,forEach, filter, reduce, assocPath,isEmpty } from 'ramda';
import api from '@synergycms_core/utils/api';
import { checkAvailSegments, round, getUniqueRef } from '../../utils';
import { fromJS, Map, List, OrderedMap } from 'immutable';
import {createActions} from 'redux-actions';

import {
  SA_BOARD,
  //AVAIL_LIFETIME,
  AD_BOARD,
  AD_BOARD_BUFFET,
} from '../../config/constants';
import actions from '../actions';
import storage from '@synergycms_core/utils/storage';
import moment from 'moment';
    import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';

let availPromise = {};

export const { setTransactionId, getAvailStore, searchAvail, setAvail, newAvail } = createActions({
  setTransactionId : transactionId => (dispatch, getState) => {
    if(transactionId){
      storage.setLocal('transaction_id', transactionId);
      dispatch(actions.customer.transactionId.set(transactionId));
    }
  },
  getAvailStore : (managerParams, flexible = false, hotelIds = [], alternatives = true) => (dispatch, getState) => {
    alternatives = !!alternatives;
    const store = getState();
    const corporateStore = store.getIn(['customer', 'corporate']) || Map();
    const companyCode = corporateStore.get('afiliado', false) || corporateStore.get('avail_code', false) || false;

    const country = store.getIn(['customer', 'country', 'code'], false);
    let queryParams = Map();

    
    if(!hotelIds.size) {
      if (store.getIn(['customer', 'current_hotel'])) {
        
        const config = contextualizeAppConfig(store, store.getIn(['customer', 'current_hotel']));
        managerParams.setBaseRef(Map({ refundability : config.get("show_all_rates_per_room") }));
        managerParams.toObj(Map({ refundability : config.get("show_all_rates_per_room") }));
        hotelIds = List([store.getIn(['customer', 'current_hotel'])]);
      } else {
        hotelIds = store.getIn(['customer', 'current_hotels']);
      }
    }

    if (companyCode) {
      queryParams = queryParams.set('avail_code', companyCode);
    }
    if (country) {
      queryParams = queryParams.set('country', country);
    }
    if (flexible) {
      queryParams = queryParams.set('refundability', 'bfr');
    }
    
    
    const stringQueryParams = managerParams.toString(queryParams);
  

    if (stringQueryParams) {
      let prevRequestedHotels = [];
      let reverseAlternatives =[];

      const filteredHotels = filter((hotelId) => {
        
        if(flexible && (
          !store.getIn(['hotels', hotelId, 'has_flexible_discount'], false) 
          || contextualizeAppConfig(store, hotelId).get("show_all_rates_per_room") === "full")
        ) {
          return false;
        }

        if(alternatives) {
          let partialRequestedAvail = availPromise[!alternatives]?.[hotelId]?.[stringQueryParams];
          partialRequestedAvail && reverseAlternatives.push(partialRequestedAvail);
        }

        let requestedAvail = availPromise[alternatives]?.[hotelId]?.[stringQueryParams];
        requestedAvail && prevRequestedHotels.push(requestedAvail);
        return !requestedAvail;
      },hotelIds.toJS());

      const setAvailPromise = (currentPromiseAvail) => {
        availPromise = reduce((acc, hotelId) => assocPath([alternatives, hotelId, stringQueryParams], currentPromiseAvail, acc), availPromise, filteredHotels)
      };

      let currentPromiseAvail = Promise.resolve();

      if (filteredHotels.length) {
        currentPromiseAvail = dispatch(newAvail(managerParams, filteredHotels, flexible, alternatives)).then(()=> managerParams.dispatch());
        setAvailPromise(currentPromiseAvail);
      }

      return Promise.all(reverseAlternatives).then(()=>{
        return Promise.all([...prevRequestedHotels, currentPromiseAvail]).then((val) => {
            filteredHotels.length && setAvailPromise(null);
            return;
        });
      });
    }
  },
  setAvail : (avails) => {
    return avails;
  },
  newAvail:
  (managerParams, filteredHotels, flexible, alternatives) =>
  (dispatch, getState)=> {
    const queryParams = managerParams.toObj();
    const flexibleKey = flexible ? "flexible_":"";
    let transactionId = getState().getIn(['customer', 'transaction_id']) || storage.getLocal('transaction_id') || false;
    dispatch(setTransactionId(transactionId));

    let guests = queryParams.get('occups');
    const totalAdults = guests.map(s => s.get('adults')).reduce((accum, v) => add(v, accum), 0) || 0;
    const totalChilds = guests.map(s => s.get('childs') || 0).reduce((accum, v) => add(v, accum), 0) || 0;

    //filtrar correctament ocupacions

    const sortOccups =sortWith([prop('adults'), prop('childs')]);
    const transformGuests = pipe(values, map(omit(['childsAge'])), sortOccups);
    const alterOccupsFnc = (val)=> sortOccups(getAlterGuests(totalAdults, totalChilds, val) || {});
    const childsInfo = pipe(values, pluck("childsAge"), flatten, reject(isNil))(guests.toJS());

    const allAvailOptions = [transformGuests(guests.toJS()), alterOccupsFnc(true), alterOccupsFnc()];
    let uniqueAllAvails = pipe(reject(isEmpty),uniqWith(equals))(allAvailOptions);


    if (childsInfo.length) {
      uniqueAllAvails = map((selection) => {
        let restChilds = childsInfo;
        return map((room)=> {
          const roomChilds = slice(0, room.childs, restChilds);
          restChilds = drop(room.childs, restChilds);
          room.childsAge = roomChilds;
          return room;
        },selection)
      },uniqueAllAvails)
    }

    //comprobar el temps de la primera peticio
    //controlar promise reject

    let prevStringParamsStoreKey = null;
    return (alternatives ? uniqueAllAvails : [uniqueAllAvails[0]]).reduce((previous, occup, index) => {

      return previous.then(() => {

        const stringQueryParamsToCall = managerParams.toString(queryParams.set("occups", fromJS(occup)));
        const stringParamsStoreKey = managerParams.toString(managerParams.refParam, true);
        prevStringParamsStoreKey = prevStringParamsStoreKey || stringParamsStoreKey;

        const alterSearchParam = index > 0 ? ',is_alter_search:1' : '';
        const requestStartTime = moment();


        if(!filteredHotels.length) {
          return Promise.resolve();
        }

        let filteredQueryHotels = filter(hotelId => {
          return !getState().getIn(["avail",hotelId, stringParamsStoreKey, `${flexibleKey}raw_response`], false);
        }, filteredHotels);


        const transactionIdParam = transactionId ? ',transaction_id:' + transactionId : '';

        return (filteredQueryHotels.length ? Promise.props({
          tester: new Promise((resolve, reject)=>{
            !flexible ? setTimeout(resolve,0) : resolve();
          }),
          avail:api.get('availability', {
            q: stringQueryParamsToCall + ',hotels:' + filteredQueryHotels.join(';') + transactionIdParam + alterSearchParam
          })}) : Promise.resolve({success : true })).then(availResponse => {
            availResponse = availResponse.avail || availResponse;
            
            if(availResponse.success === false) {
              return Promise.reject();
            }

            if(availResponse.transactionID) {
              transactionId = availResponse.transactionID;
              dispatch(setTransactionId(availResponse.transactionID));
            }

            const requestDuration = moment().diff(requestStartTime, 'milliseconds');

            let dispatchAvailResponse = {};
            const setAvailResponse = (path, currentPromiseAvail) => {
              dispatchAvailResponse =  assocPath(path, currentPromiseAvail, dispatchAvailResponse)
            };

            // TODO convertirho en 1 sol llançament d'accio al acabar el bucle unificant tots els hotels
            forEach((hotelId) => {
              const hotelAvail = availResponse[hotelId];
              const baseStore = getState().getIn(["avail", hotelId, stringParamsStoreKey], Map());
              const immutableAvail = hotelAvail ? fromJS(hotelAvail) : getState().getIn(["avail", hotelId, stringParamsStoreKey, `${flexibleKey}raw_response`], false);

              const hasAvail = prevStringParamsStoreKey && getState().getIn(["avail", hotelId, prevStringParamsStoreKey, "has_avail"]);
              const hasFlexibleAvail = prevStringParamsStoreKey && getState().getIn(["avail", hotelId, prevStringParamsStoreKey, "flexible_has_avail"]);
              const validAvail = hasAvail || hasFlexibleAvail;


              const response = baseStore.merge(Map({
                last_request: moment().valueOf(),
                request_duration: requestDuration,
                is_alter_search: index,
                [`${flexibleKey}raw_response`] : immutableAvail,
                [`${flexibleKey}has_avail`] : !!checkAvailSegments(immutableAvail)
              }));

              setAvailResponse([hotelId, stringParamsStoreKey], response);


              (!validAvail || index === 0) && managerParams.chain(hotelId);

              if(validAvail || response.get("has_avail") || response.get("flexible_has_avail")) {
                filteredHotels = without([hotelId], filteredHotels);
              }

            }, [...filteredHotels]);


            dispatch(setAvail(dispatchAvailResponse));
            managerParams.commit();

            prevStringParamsStoreKey = stringParamsStoreKey;

            return Promise.resolve();
            //TODO CATCH?
          }).catch(err => {

            let dispatchErrorResponse = {};

            filteredHotels.forEach((hotelId) => {
              let responseError = Map({
                'last_request': moment().valueOf(),
                [`${flexibleKey}raw_response`]:Map({ 'success': false })
                });
              managerParams.store([hotelId]);
              dispatchErrorResponse =  assocPath([hotelId, stringParamsStoreKey], responseError, dispatchErrorResponse)
            })

            dispatch(setAvail(dispatchErrorResponse));
            return Promise.resolve();
          });

      });
      }, Promise.resolve());
  },
});

/**
 *
 * @param service
 * @returns {function(*): (boolean|*)}
 */
export const roomCanAddService = service => roomRate =>
  !service.get('restrict_by_room_occup') ||
  service
    .get('restrictions_room_occup')
    .some(
      roomRestriction =>
        roomRate.get('room_id') === roomRestriction.get('room_occup_room_id') &&
        roomRate.get('occup_group_id') === roomRestriction.get('room_occup_occup_group_id') &&
        !roomRestriction.get('show_as_room')
    );

/**
 *
 * @param service
 * @returns {function(*): (boolean|*)}
 */
export const boardCanAddService = service => roomRate =>
  !service.get('restrict_by_board') ||
  service.get('restrictions_board').some(boardRestriction => +roomRate.get('board_id') === boardRestriction.get('id'));



/**
 *
 * @param roomsAvail
 * @param servicesAvail
 * @param flexibleAvail
 * @param promotionCode
 * @param roomsCustomOrder
 * @returns {List}
 */
export const groupAvailByRoom = (roomsAvail, servicesAvail, roomsCustomOrder, flexibleAvail, promotionCode) => {
  let groupedAvail = new List();
  // Comprovem que tots els segments demanats tinguin dispo

  if (checkAvailSegments(roomsAvail) || checkAvailSegments(flexibleAvail)) {
    groupedAvail = pipe(
      // Parseig de la dispo de node tal i com la necessitarem a front
      parseRooms((roomsAvail || List()).concat(flexibleAvail || List())),
      // Habitació + paquet
      addPackageRooms(servicesAvail),
      // Ordenem un cop ja tenim les "habitacions + paquet" agregades a la dispo
      sortRoomsByPrice(roomsCustomOrder, promotionCode),
      // Marquem quin serà el "Mejor precio" de cada segment.
      setBestPriceBySegment
    )(groupedAvail);

    // En cas d'ofuscació descomentar aquest console.log
    // console.log(groupedAvail.toJS());
  }

  return groupedAvail;
};

/**
 *
 * @param sortedAvail
 * @returns {*}
 */
const setBestPriceBySegment = sortedAvail => {
  return sortedAvail.reduce((sortedAvail, segment) => {
    segment = segment.reduce((segment, room, key) => {
      let selectedRefType = 'any';
      var roomBoard = room.get('boards').find(board => board.keySeq().find(uniqueRefType => {
        selectedRefType = uniqueRefType;
        return board.get(uniqueRefType) && (!room.get('free_breakfast') || (room.get('free_breakfast') && board.getIn([uniqueRefType, 'board_code']) !== SA_BOARD));
      }));

      return segment.set(key, roomBoard ? room.setIn(['boards', roomBoard.getIn([selectedRefType, 'board_id']), selectedRefType, 'best_price'], true) : room);

    }, new OrderedMap());
    return sortedAvail.push(segment);
  }, new List());
};

/**
 *
 * @param promotionCode
 * @param roomsCustomOrder
 * @returns {*}
 */
const sortRoomsByPrice = (roomsCustomOrder, promotionCode) => (groupedAvail) => {

  return groupedAvail.reduce((groupedAvail, segment) => {
    // ordenem les pensions per preu

    let segmentPromoCode = OrderedMap();
    segment = segment.reduce((segmentAccum, room) => {
      roomsCustomOrder.forEach((row => {
        if(row.get('room_id') === room.get('room_id') && row.get('occup_group_id') === room.get('occup_group_id') && row.get('service_id') === room.get('service_id')) {
          room = room.set('weight', row.get('weight'));
        }
      }));

      const roomId = room.get('service_id', false)
        ? room.get('room_id') + '-' + room.get('service_id')
        : room.get('room_id');

      if (room.get('promo_code') === promotionCode || room.get('service_promo_code') === promotionCode) {

        segmentPromoCode = segmentPromoCode.set(
          roomId,
          room.set('boards', room.get('boards').sortBy(b => b.getIn([getUniqueRef(b), 'price_tax'])))
        );

        return segmentAccum;

      } else {
        return segmentAccum.set(
          roomId,
          room.set('boards', room.get('boards').sortBy(b => b.getIn([getUniqueRef(b), 'price_tax'])))
        );
      }
    }, OrderedMap());

    // ordenem les habitacions per preu
    segment = segment.sortBy(room => {
      const firstBoardIndex = room
      .get('boards')
      .keySeq()
      .first();
      
      const uniqueRef = getUniqueRef(room.getIn(['boards', firstBoardIndex]));
      return room.getIn(['boards', firstBoardIndex, uniqueRef, 'price_tax']);
    }).sortBy(room => room.get('weight'));

    // ordenem les refundabilitats per preu
    let newSegment = OrderedMap();
    segment.forEach((room, idx) => {
      let newBoards = OrderedMap();
      room.get('boards').forEach((board, idx) => {
        newBoards = newBoards.set(idx, board.sortBy(b => b.get('price_tax')));
      });
      newSegment = newSegment.set(idx, room.set('boards', newBoards));
    });

    return groupedAvail.push(segmentPromoCode.merge(newSegment));
  }, new List());
};

/**
 *
 * @param roomsAvail
 * @param flexibleAvail
 * @returns {function(*): *}
 */
const parseRooms = (roomsAvail) => () => {
  let groupedAvail =  Map();
  const roomValidProps = ['room_code', 'room_id', 'room_name', 'free_breakfast', 'promo_code','room_acronym'];
  const boardValidProps = [
    'board_code',
    'board_name',
    'board_description',
    'board_id',
    'acronym',
    'price',
    'price_tax',
    'refundable',
    'discounts',
    'discount_amount',
    'discount_percent',
    'promo_description',
    'policies',
    'from_channel',
    'rate_id'
  ];

  // PRIMER NIVELL - Segments
  let groupedSegment = new OrderedMap();
  

  // Si tenim resultat a la dispo flexible ens toca reordanar com l'algoritme s'espera rebre els segments:
  // Segment 1 -> 1-any, 2-ref, 3-bfr
  // Segment 2 -> 1-any, 2-ref, 3-bfr


  roomsAvail.forEach(refTypeGroup => {
    const refType = refTypeGroup?.get('refundability');
    // Rebem 2 segments de cada refType, amb això controlem diferents segments    
    groupedSegment = groupedAvail.get(refTypeGroup.get("idx"), new OrderedMap());
    
    if (refType && refTypeGroup.get('success')) {
      refTypeGroup.get('rooms').forEach(roomRaw => {
        // Comprovació FreeBreakfast on no s'ofereix AD, forcem FreeBreakfast a FALSE
        if (
          roomRaw.get('free_breakfast', false) === true &&
          !roomRaw
            .get('boards')
            .find(b => b.getIn(['board_code']) === AD_BOARD || b.getIn(['board_code']) === AD_BOARD_BUFFET)
        ) {
          roomRaw = roomRaw.set('free_breakfast', false);
        }
        // SEGON NIVELL - Rooms
        const roomId = roomRaw.get('room_id');
        let roomQuota = false;
        if (!groupedSegment.has(roomId)) {
          groupedSegment = groupedSegment.set(
            roomId,
            roomRaw
              .filter((v, k) => roomValidProps.includes(k))
              .set('boards', new OrderedMap())
              .set('occup_group_id', refTypeGroup.get('occup_group_id'))
              .set('adults', refTypeGroup.get('adults'))
              .set('childs', refTypeGroup.get('childs'))
              .set('babies', refTypeGroup.get('babies'))
              .set('childs_info', refTypeGroup.get('childs_info'))
              .set('service_id', null)
          );
        }

        if (
          groupedSegment.getIn([roomId, 'free_breakfast'], false) === false &&
          roomRaw.get('free_breakfast', false) === true
        ) {
          groupedSegment = groupedSegment.setIn([roomId, 'free_breakfast'], true);
        }

        let boardsMap = groupedSegment.getIn([roomId, 'boards']);
        roomRaw.get('boards').forEach(boardSumRaw => {
          // TERCER NIVELL - Boards
          const boardId = boardSumRaw.get('board_id');
          let boardProps = boardSumRaw.filter((v, k) => boardValidProps.includes(k)).set('days', new OrderedMap());
          boardProps = boardProps.set('required_prepayment', boardSumRaw.get('required_prepayment', 0));
          boardProps = boardProps.set('required_prepayment_type', boardSumRaw.get('required_prepayment_type', ''));
          boardProps = boardProps.set('required_prepayment_value', boardSumRaw.get('required_prepayment_value', 0));

          let uniqueRefType = refType == "full" ? `${refType}-${refTypeGroup.get("rate_id")}` : refType;
          // QUART NIVELL - RefType (any | [ref])
          // Quan el preu es el mateix per la any i per la ref, ens quedem sempre amb la que tingui cancelació gratuita(ref)
           if (uniqueRefType === 'ref' && groupedSegment.getIn([roomId, 'boards', boardId, 'any', 'price_tax']) === boardSumRaw.get('price_tax')) {
            uniqueRefType = 'any';
            boardsMap = boardsMap.set(boardId, new Map().set(uniqueRefType, boardProps));
          }

          if (!groupedSegment.getIn([roomId, 'boards']).has(boardId)) {
            boardsMap = boardsMap.set(boardId, new Map().set(uniqueRefType, boardProps));
          } else if (!groupedSegment.getIn([roomId, 'boards', boardId, uniqueRefType])) {
            boardsMap = boardsMap.set(boardId, boardsMap.get(boardId).set(uniqueRefType, boardProps));
          }
          groupedSegment = groupedSegment.setIn([roomId, 'boards'], boardsMap);

          roomRaw.get('days').forEach(dayRaw => {
            // CINQUÉ NIVELL - Days
            const day = dayRaw.get('day'),
              dayBoard = dayRaw.getIn(['boards', dayRaw.get('boards').findIndex(b => b.get('board_id') === boardId)]),
              dayQuota = dayBoard.get('quota');
            if (roomQuota === false || dayQuota < roomQuota) {
              roomQuota = dayQuota;
            }
            boardsMap = boardsMap.setIn([boardId, uniqueRefType, 'days', day], dayBoard);
            groupedSegment = groupedSegment.set(
              roomId,
              groupedSegment
                .get(roomId)
                .set('boards', boardsMap)
                .set('quota', roomQuota)
            );
          });
        });
      });
    }

    groupedAvail = groupedAvail.set(refTypeGroup.get("idx"), groupedSegment)
  });

  return groupedAvail.toList();
};

/**
 *
 * @param servicesAvail
 * @returns {function(*=): *}
 */
const addPackageRooms = servicesAvail => groupedAvail => {
  if (servicesAvail && servicesAvail.get('success')) {
    servicesAvail.get('services').forEach(service => {
      const serviceRestriction =
        service.get('restrict_by_room_occup') &&
        service.get('restrictions_room_occup').filter(s => s.get('show_as_room'));
      const refTypeService = service.get('ref_type', 'BOTH');

      if (serviceRestriction.size) {
        serviceRestriction.forEach(s => {
          groupedAvail.forEach((segment, key) => {
            segment.forEach((room, roomId) => {
                const roomServiceMatch =
                  room.get('room_id') === s.get('room_occup_room_id') &&
                  room.get('occup_group_id') === s.get('room_occup_occup_group_id') &&
                  room.get('service_id') === null;
                if (roomServiceMatch) {
                  let serviceRoom = clone(room).set('service_id', service.get('id'));
                  if (service.get('promo_code')) {
                    serviceRoom = serviceRoom.set('service_promo_code', service.get('promo_code'));
                  }
                  s.get('show_service_image') && (serviceRoom = serviceRoom.set('service_image', service.get('image')));
                  s.get('show_service_description') && (serviceRoom = serviceRoom.set('service_description', service.get('description')));
                  const guestsCount = serviceRoom.get('adults') + serviceRoom.get('childs');
                  const availableTypes = ['person', 'person_night', 'Per person', 'Per person per night'];
                  let servicePrice = 0,
                    servicePriceTax = 0;

                  serviceRoom.get('boards').forEach((board, boardId) => {
                    const hasBoardRestriction =
                      !service.get('restrict_by_board') ||
                      (service.get('restrict_by_board') &&
                        service.get('restrictions_board').some(b => b.get('id') === +boardId));
                    if (hasBoardRestriction) {
                      board.forEach((roomBoard, uniqueRefType) => {
                        const refundableCheck = uniqueRefType !== 'ref' || service.get('refundable');
                        if (refundableCheck) {
                          // Precio cerrado
                          const hasClosedPrice = service.get('has_closed_price') === true;
                          if (hasClosedPrice) {
                            roomBoard = parsePackageClosedPrice(roomBoard, service, guestsCount);

                            const refundabilityPriceCheck = uniqueRefType === 'ref' &&
                              roomBoard.get('price_tax') === serviceRoom.getIn(['boards', boardId, 'any', 'price_tax']);

                            serviceRoom = serviceRoom.setIn(['boards', boardId, uniqueRefType], roomBoard).set(
                              'free_breakfast',
                              false
                            );

                            if (refundabilityPriceCheck) {
                              if (serviceRoom.getIn(['boards', boardId, 'ref']) && service.get('refundable')) {
                                serviceRoom = serviceRoom.setIn(
                                  ['boards', boardId, 'any'],
                                  parsePackageRoomPenalties(roomBoard, service)
                                );
                              }
                              serviceRoom = serviceRoom.setIn(['boards', boardId], serviceRoom.getIn(['boards', boardId]).remove('ref'));
                            }
                          }
                          // Sin precio cerrado
                          else {
                            servicePrice = parseFloat(service.get('price'));
                            servicePriceTax = parseFloat(service.get('price_tax'));
                            if (availableTypes.includes(service.get('type'))) {
                              // Es multiplica pel nº de persones (les nits ja venen calculades del servidor)
                              if (service.get('has_price_per_child', false)) {
                                const serviceChildPrice = parseFloat(service.get('child_price'));
                                const serviceChildPriceTax = parseFloat(service.get('child_price_tax'));
                                servicePrice = (servicePrice * (parseInt(serviceRoom.get('adults'), 10)) + (serviceChildPrice * parseInt(serviceRoom.get('childs'), 10)));
                                servicePriceTax = (servicePriceTax * (parseInt(serviceRoom.get('adults'), 10)) + (serviceChildPriceTax * parseInt(serviceRoom.get('childs'), 10)));
                              } else {
                                servicePrice *= parseInt(guestsCount, 10);
                                servicePriceTax *= parseInt(guestsCount, 10);
                              }
                            }

                            roomBoard = roomBoard
                              .set('room_board_price', roomBoard.get('price'))
                              .set('room_board_price_tax', roomBoard.get('price_tax'))
                              .set('service_price', servicePrice)
                              .set('price', roomBoard.get('price') + servicePrice)
                              .set('price_tax', roomBoard.get('price_tax') + servicePriceTax);
                          }
                          if (serviceRoom.getIn(['boards', boardId, uniqueRefType])) {
                            // Merge de polítiques de Servei Vs Habitació
                            serviceRoom = serviceRoom.setIn(['boards', boardId, uniqueRefType], parsePackageRoomPenalties(roomBoard, service));
                          } else {
                            serviceRoom = removeRefTypeBoard(serviceRoom, boardId, uniqueRefType);
                          }
                        } else {
                          // Eliminem el resultat de dispo "refundable" quan el servei sumat
                          // faci que es converteixi a "not refundable"
                          serviceRoom = removeRefTypeBoard(serviceRoom, boardId, uniqueRefType);
                        }
                      });
                    } else {
                      // Eliminem pensió restringida
                      serviceRoom = serviceRoom.set('boards', serviceRoom.get('boards').remove(boardId));
                    }
                  });

                  if (refTypeService !== 'BOTH') {
                    const wantRefundable = refTypeService === 'MTR';

                    serviceRoom.get('boards', OrderedMap()).forEach((refTypes, boardId) => {
                      let kept = refTypes.filter(
                        b => !!b && (b.getIn(['policies', 'nr']) === false) === wantRefundable
                      );

                      if (kept.has('ref')) {
                        kept = kept.set('any', kept.get('ref'));
                      }
                      kept = kept.remove('ref');

                      serviceRoom = kept.size
                        ? serviceRoom.setIn(['boards', boardId], kept)
                        : serviceRoom.set('boards', serviceRoom.get('boards').remove(boardId));
                    });
                  }

                  // Si tot està correcte afegim l'habitació + paquet al segment
                  if (serviceRoom.get('boards', OrderedMap).size > 0) {
                    groupedAvail = groupedAvail.setIn([key, roomId + '-' + service.get('id')], serviceRoom);
                  }
                }
              }
            );
          });
        });
      }
    });
  }
  return groupedAvail;
};

/**
 *
 * @param roomBoard
 * @param service
 * @param guestsCount
 * @returns {*}
 */
const parsePackageClosedPrice = (roomBoard, service, guestsCount) => {
  const availableTypes = ['person', 'person_night', 'Per person', 'Per person per night'];
  const closedPriceBoard = service.get('has_closed_price_board');
  const serviceTaxesIncluded = service.get('taxes_included');
  const serviceTaxPercent = service.get('tax_percentage');
  const closedPriceIsPercent = service.get('closed_price_is_percent');
  let closedPriceValue = service.get('closed_price_value');

  roomBoard.get('days').forEach((dayBoard, day) => {
    const serviceDay = service.get('days').find(d => d.get('day') === day);
    if (serviceDay) {
      let serviceDayClosedPrice = serviceTaxesIncluded ? serviceDay.get('price_tax') : serviceDay.get('price');
      let totalDayPrice = serviceDayClosedPrice;
      if (availableTypes.includes(service.get('type'))) {
        // Es multiplica pel nº de persones (les nits ja venen calculades del servidor)
        serviceDayClosedPrice *= guestsCount;
      }

      if (closedPriceValue > serviceDayClosedPrice) {
        closedPriceValue = serviceDayClosedPrice;
      }

      const serviceDayPrice = closedPriceIsPercent
        ? (serviceDayClosedPrice * closedPriceValue) / 100
        : closedPriceValue;
      let dayRoomBoardPrice = serviceDayClosedPrice - serviceDayPrice;

      if (!closedPriceBoard) {
        dayRoomBoardPrice += dayBoard.get('board_price');
        totalDayPrice += dayBoard.get('board_price');
      }

      // recalculem preu d'habitació
      dayBoard = dayBoard
        .set('discounts', [])
        .set('discount_amount', 0)
        .set('discount_percent', 0)
        .set('price', serviceTaxesIncluded ? totalDayPrice / (1 + serviceTaxPercent / 100) : totalDayPrice)
        .set('price_tax', serviceTaxesIncluded ? totalDayPrice : totalDayPrice * (1 + serviceTaxPercent / 100))
        .set(
          'room_board_price',
          serviceTaxesIncluded ? dayRoomBoardPrice / (1 + serviceTaxPercent / 100) : dayRoomBoardPrice
        )
        .set(
          'room_board_price_tax',
          serviceTaxesIncluded ? dayRoomBoardPrice : dayRoomBoardPrice * (1 + serviceTaxPercent / 100)
        )
        .set('service_price', serviceTaxesIncluded ? serviceDayPrice / (1 + serviceTaxPercent / 100) : serviceDayPrice);

      roomBoard = roomBoard.setIn(['days', day], dayBoard);
    }
  });

  return roomBoard
    .set('discount_percent', 0)
    .set('discount_amount', 0)
    .set('price', roomBoard.get('days').reduce((sum, el) => sum + el.get('price'), 0))
    .set('price_tax', roomBoard.get('days').reduce((sum, el) => sum + el.get('price_tax'), 0))
    .set('room_board_price', roomBoard.get('days').reduce((sum, el) => sum + el.get('room_board_price'), 0))
    .set('room_board_price_tax', roomBoard.get('days').reduce((sum, el) => sum + el.get('room_board_price_tax'), 0))
    .set('service_price', roomBoard.get('days').reduce((sum, el) => sum + el.get('service_price'), 0));
};

/**
 *
 * @param roomBoard
 * @param service
 * @returns {*}
 */
const parsePackageRoomPenalties = (roomBoard, service) => {
  const days = roomBoard.get('days').size;
  // case service NR
  if (roomBoard.getIn(['policies', 'nr']) === false && service.get('refundable') === false) {
    roomBoard = roomBoard.set('policies', service.get('policies'));
  }
  // case service Ref
  else if (roomBoard.getIn(['policies', 'nr']) === false && service.get('refundable') === true) {
    if (service.getIn(['policies', 'penalties']).size > 0) {
      const roomPenalty = roomBoard.getIn(['policies', 'penalties', 0]);

      const getPercentage = (penalty) => {      //TODO : fix penalty.amount
        const penaltyValue = penalty.get('value');
        let percentage = 0;
        if (penalty.get('type') === 'percentage') {
          percentage = penaltyValue;
        } else {
          percentage = penaltyValue >= days ? 100 : (penaltyValue * 100) / days;
        }
        return percentage;
      };

      const normalizeRelease = (penalty) => {
        if (penalty.get('same_day') && penalty.get('same_day') !== "N/A" && penalty.get('same_day') !== "") {
          return penalty.get('release') / 3.6e6;
        }
        return penalty.get('release');
      };

      const servicePenalty = service.getIn(['policies', 'penalties']).reduce((best, current) => {
        if (!best) return current;

        if (getPercentage(current) > getPercentage(best)) {
          return current;
        }

        if (
          getPercentage(current) === getPercentage(best) &&
          normalizeRelease(current) > normalizeRelease(best)
        ) {
          return current;
        }

        return best;
      }, null);

      const penaltyCheck =
      ((getPercentage(servicePenalty) > getPercentage(roomPenalty)) && (normalizeRelease(servicePenalty) >= normalizeRelease(roomPenalty))) ||
      ((getPercentage(servicePenalty) === getPercentage(roomPenalty)) && (normalizeRelease(servicePenalty) > normalizeRelease(roomPenalty)));

      if (penaltyCheck) {
        roomBoard = roomBoard
          .setIn(['policies', 'description'], service.getIn(['policies', 'description']))
          .setIn(['policies', 'penalties'], roomBoard.getIn(['policies', 'penalties']).unshift(servicePenalty));
      }
    }
  }

  return roomBoard;
};

/**
 *
 * @param room
 * @param boardId
 * @param refType
 * @returns {__Cursor.Cursor | Immutable.List<T> | Immutable.Map<K, V>}
 */
const removeRefTypeBoard = (room, boardId, refType) => {
  return room.setIn(['boards', boardId], room.getIn(['boards', boardId]).remove(refType));
};

/**
 * Recerca alternativa de disponibilitat separant en segments de 2 adults
 * Amb el paràmetre lastSingle === true s'intentarà buscar ocupacions intentant assignar un adult a l'ultim segment (en cas d'imparells)
 * mentres que amb el paràmetre a false s'intentarà sempre que l'últim segment estigui ocupat per 3 adults
 * Els nens sempre es reparteixen equitativament entre tots els segments prioritzant els segments amb menys adults
 * @param adults
 * @param children
 * @param lastSingle
 * @returns {any}
 */
const getAlterGuests = (adults, children, lastSingle = false) => {
  const evenAdults = adults % 2 === 0,
    twoAdults = evenAdults && adults === 2,
    segments = evenAdults
      ? twoAdults && lastSingle
        ? 2
        : adults / 2
      : Math[lastSingle ? 'ceil' : 'floor'](adults / 2),
    segmentChilds = children > segments ? Math.ceil(children / segments) : 1,
    guests = [];
  let segmentAdults, i;

  for (i = 0; i < segments; i++) {
    if (lastSingle) {
      if (twoAdults) {
        segmentAdults = 1;
      } else {
        segmentAdults = evenAdults || i > 0 ? 2 : 1;
      }
    } else {
      if (twoAdults) {
        segmentAdults = 2;
      } else {
        if (i === segments - 1) {
          segmentAdults = 3;
        } else if (i === 0) {
          segmentAdults = evenAdults ? 1 : 2;
        } else {
          segmentAdults = 2;
        }
      }
    }

    guests.push({
      adults: segmentAdults,
      childs: children < segmentChilds ? children : segmentChilds
    });

    if (children > segmentChilds) {
      children -= segmentChilds;
    } else {
      children = 0;
    }
  }
  const cleanGuest = map(reject(equals(0)), guests);
  return cleanGuest.length ? cleanGuest.reverse() : null;
};


const getBestRestrictionPriceRoom = (rooms) => {
  const sorted = rooms.sort((a, b) => {
    if(!a.get('applied_restrictions') && !b.get('applied_restrictions')) return 0;
    if(!a.get('applied_restrictions')) return 1;
    if(!b.get('applied_restrictions')) return -1;

    const aRestrictions = a.get('applied_restrictions').find(restriction => restriction.get('type') === "min_days") || Map({value: 0});
    const bRestrictions = b.get('applied_restrictions').find(restriction => restriction.get('type') === "min_days") || Map({value: 0});
    return aRestrictions.get('value') - bRestrictions.get('value');
  });
  return sorted.get(0, Map());
}


export const parseAvail = (avail, minPrice = null, maxPrice = null, freeBreakFast = null, showTaxes, roomId = false) => {
  const baseRange = avail.map(currentRange =>
    Map({
      showTaxes: showTaxes,
      checkin: currentRange.get('checkin'),
      checkout: currentRange.get('checkout'),
      adults: currentRange.get('adults'),
      childs: currentRange.get('childs'),
      babies: currentRange.get('babies'),
      childsInfo: currentRange.get('childs_info'),
      data: null
    })
  );
  //index del dia
  let idx = 0;
  let boardList = avail.reduce((boards, currentRange) => {
    minPrice = !minPrice ? maxPrice : minPrice;
    let room;
    if (roomId) {
      room = currentRange.get('rooms', List()).find((room) => {
        return roomId === room.get('room_id');
      }) || Map();
    } else {
      room = getBestRestrictionPriceRoom(currentRange.getIn(['rooms'], List())) || Map();
    }

    let isFreeBreakFastDay = room.get('free_breakfast');

    //realitzem l'acumulat de freekBreakfast per mostrar o no la pensio per defecte
    freeBreakFast = null === freeBreakFast || freeBreakFast ? isFreeBreakFastDay : false;
    const currentRangeboards = room.getIn(['boards'], List());

    //recuperem els detalls diaris de per totes les pensions d'aquell dia
    const daysList = room.getIn(['days'], List());

    let newBoards =
      currentRangeboards &&
      currentRangeboards.map(board => {
        //recuperem board del llistat acumulat o inicialitzem nova
        const selectedBoard = boards.get(
          board.get('board_id'),
          Map({
            freeBreakFast: isFreeBreakFastDay,
            baseRange: baseRange,
            board_id: board.get('board_id'),
            name: board.get('board_name'),
            board_code: board.get('board_code')
          })
        );


        const excludeBaseBoard = !isFreeBreakFastDay || (isFreeBreakFastDay && board.get('board_code') !== SA_BOARD);

        let boardsDayList = List();
        if (excludeBaseBoard) {
          //recuperem el grup de dies associat aquell dia d'inici i per aquella pensio
          boardsDayList = daysList.reduce((currentRange, day) => {
            return currentRange.push(
              Map({ day: day.get('day') }).merge(
                day.get('boards').find(board => board.get('board_id') === selectedBoard.get('board_id'))
              )
            );
          }, List());
        }

        //realitzem l'acumulat de preu minim i maxim
        maxPrice = board.get('price_tax') > maxPrice ? board.get('price_tax') : maxPrice;
        minPrice = board.get('price_tax') > minPrice ? minPrice : board.get('price_tax');

        //assignem el resum de pensio per aquell dia + l'informacio dels dies de la reserva
        return excludeBaseBoard
          ? selectedBoard.updateIn(['baseRange', idx], value => value.merge(board.set('applied_restrictions', room.get('applied_restrictions'))).set('dayList', boardsDayList))
          : selectedBoard;
      });

    idx++;
    //convertim a map per la gestió de pensions duplicades
    const mapBoards = Map(newBoards.map(v => [v.get('board_id'), v]));

    return (mapBoards.size && boards.merge(mapBoards || Map())) || boards;
  }, Map());


  boardList = boardList.filter(board => {
    return (
      (!freeBreakFast ||
        (freeBreakFast && board.get('board_code') !== SA_BOARD)) &&
      board.get('baseRange').some(day => day.get('price'))
    );
  });

  if (!boardList.size) {
    boardList = List([Map({ baseRange: avail, board_id: 0, name: 'Calendar' })]);
  }

  return Map({ minPrice, maxPrice, boardList: boardList.valueSeq(), freeBreakFast });
};




export const getLoyaltyDiscount = (store) => {

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']),
    'response'
  ]);

  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  let loyaltyDiscount = 0;
  if(!!reservationBlocks && !!loyaltyRoomsAvail && store.getIn(['customer', 'reservation_request', 'loyalty'], false)) {

    loyaltyDiscount = reservationBlocks.reduce((value, block, idx) => {

      const selectedRateAvail = loyaltyRoomsAvail.getIn([
        idx,
        block.get('room_id'),
        'boards',
        block.get('board_id'),
        block.get('unique_ref_type')
      ]);

      const computedDiscountValue =
        selectedRateAvail &&
        selectedRateAvail.get('days').reduce((total, day) => {

          day.get('discounts', List()).forEach(discount => {
            
              let discountValue = 0;

              if(discount.get('is_loyalty')) {
                const baseDiscountValue = Math.abs(discount.get('amount', 0));
                if (!day.get('taxes_included') && hotel.get('show_taxes')) {
                  discountValue = baseDiscountValue + (baseDiscountValue * day.get('tax_percent')) / 100;
                } else if (day.get('taxes_included') && !hotel.get('show_taxes')) {
                  discountValue = baseDiscountValue / (day.get('tax_percent') / 100 + 1);
                } else {
                  discountValue = discount.get('amount', 0);
                }
                
              }
              total =total + (discountValue || 0)
          });

          return total;
        }, 0);
      return value + computedDiscountValue;
    }, 0);
    if (loyaltyDiscount > 0) {
      loyaltyDiscount *= -1;
    }
  }

  return loyaltyDiscount;
}


export const getLoyaltyAvailDiscountPercent = (store) => {

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const path = store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']);
  let percentDiscount = 0;

  const rawResponse = store.getIn(['avail', hotelId, path, 'raw_response'], List());
  rawResponse.some(response =>
    response.get('rooms', List()).some(room =>
      room.get('boards', List()).some(board => {
        const discount = board.get('discounts', List()).find(d => d.get('is_loyalty') && d.get('percent', 0) < 0);
        if (discount) {
          percentDiscount = discount.get('percent');
        }
        return !!discount;
      })
    )
  );

  // Only flexible avail
  if (percentDiscount === 0) {
    const flexibleResponse = store.getIn(['avail', hotelId, path, 'flexible_raw_response'], List());
    flexibleResponse.some(response =>
      response.get('rooms', List()).some(room =>
        room.get('boards', List()).some(board => {
          const discount = board.get('discounts', List()).find(d => d.get('is_loyalty') && d.get('percent', 0) < 0);
          if (discount) {
            percentDiscount = discount.get('percent');
          }
          return !!discount;
        })
      )
    );
  }

  return round(percentDiscount);
};


/**
 * Devuelve true si la reserva lleva un descuento loyalty REALMENTE aplicado (no confundir
 * con "usuario logueado", que solo indica el nivel del cliente).
 *
 * El descuento aplicado vive a nivel de dia: blocks[].days[].discounts[] con is_loyalty.
 * El listado blocks[].discounts / reservation.discounts es un catalogo de descuentos de la
 * reserva y puede contener entradas que no se han aplicado a la tarifa seleccionada, por eso
 * no sirve para decidir si se pinta el bloque de fidelizacion.
 *
 * @param reservationLike reservation o reservation_request (Immutable Map)
 * @return {boolean}
 */
export const hasAppliedLoyaltyDiscount = (reservationLike) => {
  const blocks = reservationLike && reservationLike.get && reservationLike.get('blocks', List());
  if (!blocks || !blocks.size) return false;

  return blocks.some(block =>
    block.get('days', List()).some(day =>
      day.get('discounts', List()).some(discount => discount.get('is_loyalty'))
    )
  );
};

/**
 * Return the boards with the selected refundability
 * @param boards
 * @param refundability
 */
const filterBoardsByRefundability = (boards, refundability) => {
  var result = new OrderedMap();
  boards && boards.forEach((board, boardId) => {
    const newRef = board && board.filter((object,id) => {
      return id === refundability
    })
    if(newRef.size) result = result.set(boardId, newRef);
  });
  return result;
}

/**
 * Return the boards with the selected boardId
 * @param boards
 * @param boardId
 */
const filterBoardsByBoardId = (boards, boardId) => {
  return boards && boards.filter(board => {
    let found = false
    board && board.forEach(ref => {
      if(!isNaN(boardId) && ref?.get('board_id').toString() === boardId) found = true;
      else if(isNaN(boardId) && ref?.get('acronym') === boardId) found = true;
    })
    return found;
  });
}

/**
 * Return the boards with the selected boardId and refundability
 * @param boards
 * @param boardId
 * @param refundability
 */
const filterBoards = (boards, { boardId, refundability }) => {
  var newBoards = boards;
  if(refundability) newBoards = filterBoardsByRefundability(newBoards, refundability)
  if(boardId) newBoards = filterBoardsByBoardId(newBoards, boardId)
  return newBoards;
}

/**
 * Filter the avail data by the selected filters. It can filter by roomId, boardId and refundability
 * @param avail
 * @param selection
 */
export const filterAvailSection = (avail,selection) => {
  const newRooms = avail && avail.map(roomType => {
    // filter by roomId if room filter in selection is set
    if(!!selection.get('room')) {
      if(!isNaN(selection.get('room')) && 
          (roomType?.get('room_id').toString() !== selection.get('room') && roomType.get('room_acronym') !== selection.get('room'))){ 
        return undefined;
      }
      else if(isNaN(selection.get('room')) && roomType.get('room_acronym') !== selection.get('room')){ 
        return undefined;
      }
    }

    // filter room by board and refundability
    var newBoards = filterBoards(roomType.get('boards'),{boardId: selection.get('board'), refundability: selection.get('type')})

    if(newBoards.size) return roomType.set('boards', newBoards);
    return undefined;
  }).filter(Boolean);
  
  if(newRooms.size) return newRooms;
  return new Map({filter_success: false})
}

/**
 * Filter the avail result by the selected filters. It can filter by roomId, boardId and refundability
 * @param avail
 * @param selection
 */
export const filterAvail = (avail,selection) => {
  let newAvail = List()
  avail && avail.forEach((data,key) => {
    const filtered = filterAvailSection(data, selection.get(key))
    newAvail = selection.get(key) ? newAvail.set(key, filtered) : newAvail.set(key, data);
  })
  return newAvail;
}

export const roomsSelectionIsComplete = (rooms) => {
  if (!rooms || rooms.size > 1) return false;

  const room = rooms.first();

  if (!room?.get('boards') || room.get('boards').size > 1) return false;

  const board = room.get('boards').first();

  return board?.size === 1;
};

export const selectionIsComplete = (filteredAvail, all = false) => {
  if (all) {
    return filteredAvail?.every(rooms => roomsSelectionIsComplete(rooms)) ?? false;
  }
  return filteredAvail?.some(rooms => roomsSelectionIsComplete(rooms)) ?? false;
};